import React, { useEffect, useState } from 'react';
import { Badge, Card, Col, Row, Tag } from 'antd';
import { getAllCouriers } from 'store/requests/courier';
import { Client } from '@stomp/stompjs';
import { COURIER_STATUS } from 'helpers/constants';
import { useTranslation } from 'react-i18next';

const AllCouriers = (props) => {
  const [allCourier, setAllCourier] = useState([]);
  const [connectSocket, setConnectSocket] = useState(false);
  const location = window.location.host;
  const ws = `wss://${location}/websocket`;
  const { t } = useTranslation();

  useEffect(() => {
    getAllCouriers(props.zone).then((couriers) => {
      setAllCourier(couriers.data);
      setConnectSocket(!connectSocket);
    });
  }, [props.zone]);

  const setAll = (allCourierState) => {
    setAllCourier([...allCourierState]);
  };

  useEffect(() => {
    const client = new Client({
      brokerURL: `${ws}/live-feed`,
      reconnectDelay: 10000,
      heartbeatOutgoing: 45000,
      heartbeatIncoming: 45000,
    });

    client.onConnect = function (frame) {
      client.subscribe(
        '/user/queue/courier-connection-status-stream',
        function (message) {
          const payload = JSON.parse(message.body);
          const allCourierNew = allCourier;
          if (allCourierNew.length > 0) {
            allCourierNew.forEach((courier) => {
              if (courier.phoneNumber === payload.courierCode) {
                courier.isOnline = payload.online;
              }
            });
            allCourierNew.sort((b, a) => a.isOnline - b.isOnline);
            setAll(allCourierNew);
          }
        },
        { 'auto-delete': true },
      );
    };

    client.onStompError = function (frame) {
      console.log('Broker reported error: ');
      console.log(frame.headers['message']);
      console.log('Additional details: ', frame.body);
      client.deactivate();
    };

    client.activate();
    return () => {
      client.deactivate();
    };
  }, [connectSocket]);

  return (
    <Col span={24}>
      {allCourier &&
        allCourier.map((courier, index) => (
          <Card className="CourierCard" key={index}>
            <Row>
              <Col span={7} className="CourierCardImage">
                <Badge
                  dot
                  status={courier.isOnline ? 'success' : 'danger'}
                  style={{ height: '15px', width: '15px' }}
                >
                  <img
                    src={
                      courier.imageUrl
                        ? courier.imageUrl
                        : '/static/img/user.svg'
                    }
                    alt="profile pic"
                  />
                </Badge>
              </Col>
              <Col span={16} className="CourierCardInfo">
                <p>{courier.fullName}</p>
                <p>{courier.phoneNumber}</p>
                <p>{courier.plateNumber}</p>
                <Tag
                  className="StatusTag"
                  color={
                    !courier.isOnline
                      ? 'red'
                      : courier.status === t(COURIER_STATUS.ON_HOLD)
                        ? 'gold'
                        : 'green'
                  }
                >
                  {!courier.isOnline
                    ? t(COURIER_STATUS.OFFLINE)
                    : courier.status}
                </Tag>
              </Col>
            </Row>
          </Card>
        ))}
    </Col>
  );
};

export default AllCouriers;
